import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { Dictionary, TsButtonModule, TSIconModule } from 'tsui';

@Component({
  standalone: true,
  imports: [MatIconModule, TSIconModule, TsButtonModule, TSIconModule, RouterModule],
  template: `
    <!-- Hide button if row is pinned (used when openDetails and footer renderers are active)-->
    @if (url) {
      <a [routerLink]="url" [queryParams]="queryParams"><ts-icon icon="open_in_new"></ts-icon></a>
    } @else {
      <ts-button
        type="icon"
        color="accent"
        icon="open_in_new"
        [hidden]="params?.node.rowPinned"
        (click)="onClick()"
      ></ts-button>
    }
  `,
})
export class TableOpenDetailsRendererComponent implements ICellRendererAngularComp {
  params: any;
  url: string;
  queryParams: Dictionary<string> = {};

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if (this.params.openDetailsLinkBuilder) {
      const link = this.params.openDetailsLinkBuilder(this.params.data);
      this.url = link.url;
      this.queryParams = link.queryParams ?? {};
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onClick(): void {
    if (this.params && this.params.onOpenDetails) {
      this.params.onOpenDetails(this.params.data);
    }
  }
}
